import IdButton from '../../../components/IdButton'
import Form from '../../../components/form/Form'
import { useStepsContext } from '../../../context/StepsContext'
import useFormFields from '../../../hooks/useFormFields'
import AddressForm from './AddressForm'
import ExtLanding from './ExtLanding'

const ManualIdForm = () => {
  const { idStep }: any = useStepsContext()
  const { idNominativityFields } = useFormFields()
  const storeForm = 'idNominativityForm'

  const clientDataForm = (
    <main className="form">
      <div className="form-container">
        <h2 id="manual-cargar-datos">Cargá los datos del cliente</h2>
        <Form fields={idNominativityFields} storeForm={storeForm} inputsPosition="floating" />

        <div className="form-action">
          <IdButton storeForm={storeForm} procedure="nominativity" />
        </div>
      </div>
    </main>
  )

  return (
    <>
      {idStep === 1 && clientDataForm}

      {idStep === 2 && <AddressForm />}

      {idStep === 3 && <ExtLanding side="front" />}

      {idStep === 4 && <ExtLanding side="back" />}

      {idStep === 5 && <ExtLanding side="photo" photo />}
    </>
  )
}

export default ManualIdForm
